export const AboutSliceConstants = {
  GetAboutDescription: 'getAboutDescription',
};
